module.exports = __webpack_public_path__ + "img/care-promise-rtw.023ec127.png";